import React from 'react'

export default function Viewport() {
    return (
        <div className="viewport">
            <div className="close-button">
                <div className="button_"><span className="lines"></span></div>
            </div>
            <div className="images">
                <div className="before"></div>
                <div className="after"></div>
                <div className="loader"></div>
                <div className="image"></div>
            </div>
        </div>

    )
}


